import type { Revision, RevisionPageDocument, RevisionPageLink } from '../../types';
import { mutations } from '../../utils';
import { getPageAncestorsInRevision } from './getPageAncestorsInRevision';
import { getPageChildrenInRevision } from './getPageChildrenInRevision';
import { isRevisionPageParent } from './guards';

/**
 * Get all descendants of a page.
 */
export function getPageDescendantsInRevision(
    revision: Revision,
    pageId: string
): (RevisionPageDocument | RevisionPageLink)[];
export function getPageDescendantsInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPageDocument | RevisionPageLink>[];
export function getPageDescendantsInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPageDocument | RevisionPageLink>[] {
    const children = getPageChildrenInRevision(revision, pageId);
    const descendants: mutations.MutableData<RevisionPageDocument | RevisionPageLink>[] = [];

    children.forEach((child) => {
        descendants.push(child);

        if (isRevisionPageParent(child)) {
            // @ts-ignore
            descendants.push(...getPageDescendantsInRevision(revision, mutations.get(child, 'id')));
        }
    });

    return descendants;
}

/**
 * Test if a page is a descendant of another one.
 */
export function isPageDescendant(
    revision: mutations.MutableData<Revision>,
    ancestorId: string,
    pageId: string
): boolean {
    const page = mutations.getIn(revision, ['pages', pageId] as const);
    if (!page) {
        return false;
    }

    const ancestors = getPageAncestorsInRevision(revision, pageId);
    return ancestors.some((ancestor) => mutations.get(ancestor, 'id') === ancestorId);
}
